/** @description 헤더 컴포넌트에 경로에 따라 표시되는 드로어 아이콘, 뒤로가기 아이콘, 버전이 표시되어야 하는 경로를 정의 */
export const headerConfig = {
  showGoBack: [
    '/register',
    '/register/phone-verification',
    '/find-id',
    '/find-id/success',
    '/reset-pw',
    '/reset-pw/set-new-pw',
    '/start-work/select-work-info',
    '/monthly-timeline',
    '/monthly-timeline/register-work-plan',
    '/leave-early',
    '/change-pw',
    '/contract/caution',
    '/contract/contract-user-info',
    '/contract/contract-work-info',
    '/contract/contract-sign',
    '/contract/phone-certificate',
    '/pay-statement',
    '/pay-statement/detail/per-diem',
    '/pay-statement/detail/holiday',
    '/pay-statement/detail/special-pro',
    '/pay-statement/detail/annual',
    '/pay-statement/check-password',
    '/contract-management',
    '/submit-special-medical',
    '/submit-special-medical/preview-image',
    '/submit-special-medical/camera-result',
    '/settings',
    '/settings/modify-user-info/check-password',
    '/settings/modify-user-info',
    '/settings/change-phone-number',
    '/settings/withdraw-account',
    '/settings/change-password',
    '/settings/recruit-agreement',
    '/work-apply-list',
    '/work-apply-list/detail',
    '/work-apply/change-phone-number',
  ],
  showClose: [
    '/contract/search-post-code',
    '/settings/search-post-code',
    '/work-apply/guideline',
    '/work-apply/policy-agree',
    '/work-apply/info',
    '/work-apply/check-info',
    '/work-apply/select-workplace',
    '/work-apply/select-date',
    '/work-apply/select-task',
    '/work-apply/select-work-description',
    '/work-apply/select-commute-method',
    '/check-network',
  ],
  showDrawer: [
    '/not-found',
    '/start-work',
    '/before-work',
    '/contract-management',
    '/pay-statement',
    '/pay-statement/detail/per-diem',
    '/pay-statement/detail/holiday',
    '/pay-statement/detail/special-pro',
    '/pay-statement/detail/annual',
    '/submit-special-medical',
    '/monthly-timeline',
    '/work-apply-list',
  ],
  showAppLogo: ['/before-work', '/start-work', '/not-found', ...(!window?.webkit && !window?.JSBridge ? ['/'] : [])],
};

/** @description 라우팅 경로에 따른 페이지 제목을 맵핑 */
export const pageTitles: { [key: string]: string } = {
  '/work-apply': '근무 지원',
  '/work-apply/guideline': '지원 전 유의사항',
  '/work-apply/policy-agree': '개인정보 동의',
  '/work-apply/info': '근무 지원 정보',
  '/work-apply/check-info': '근무 지원 정보',
  '/work-apply/select-workplace': '근무지 선택',
  '/work-apply/select-date': '근무일 선택',
  '/work-apply/select-task': '업무 선택',
  '/work-apply/select-work-description': '근무 시간/환경 선택',
  '/work-apply/select-commute-method': '출근 방법 선택',
  '/work-apply/change-phone-number': '휴대폰 번호 변경',
  '/work-apply-list': '나의 지원 내역',
  '/work-apply-list/detail': '근무 지원 상세',
  '/work-apply/submit': '',
  '/guest/work-apply': '근무 지원',
  '/guest/work-apply/guideline': '지원 전 유의사항',
  '/guest/work-apply/policy-agree': '개인정보 동의',
  '/guest/work-apply/info': '근무 지원 정보',
  '/guest/work-apply/select-workplace': '근무지 선택',
  '/guest/work-apply/select-date': '근무일 선택',
  '/guest/work-apply/select-task': '업무 선택',
  '/guest/work-apply/select-work-description': '근무 시간/환경 선택',
  '/guest/work-apply/select-commute-method': '출근 방법 선택',
  '/guest/work-apply/submit': '',
  '/guest/work-apply-list': '나의 지원 내역',
  '/guest/work-apply-list/detail': '근무 지원 상세',
  '/register': '회원가입',
  '/register/phone-verification': '회원가입',
  '/find-id': '아이디 찾기',
  '/find-id/success': '아이디 찾기',
  '/change-pw': '비밀번호 변경',
  '/reset-pw': '비밀번호 초기화',
  '/reset-pw/set-new-pw': '비밀번호 변경',
  '/contract/caution': '계약 전 유의사항',
  '/contract/contract-user-info': '계약 체결 정보',
  '/contract/search-post-code': '주소 검색',
  '/contract/phone-certificate': '본인인증',
  '/contract/contract-work-info': '근무 정보',
  '/contract/contract-sign': '계약서 확인',
  '/start-work/select-work-info': '근무 정보',
  '/monthly-timeline': '나의 근무',
  '/monthly-timeline/register-work-plan': '근무 등록 요청',
  '/leave-early': '조퇴',
  '/contract-management': '계약서 관리',
  '/pay-statement': '급여명세서',
  '/pay-statement/check-password': '비밀번호 입력',
  '/pay-statement/detail/per-diem': '급여명세서 상세',
  '/pay-statement/detail/holiday': '급여명세서 상세',
  '/pay-statement/detail/special-pro': '급여명세서 상세',
  '/pay-statement/detail/annual': '급여명세서 상세',
  '/submit-special-medical': '검진 확인서 제출',
  '/submit-special-medical/preview-image': '',
  '/submit-special-medical/camera-result': '미리보기',
  '/settings': '설정',
  '/settings/modify-user-info/check-password': '비밀번호 입력',
  '/settings/modify-user-info': '내 정보 관리',
  '/settings/search-post-code': '주소 검색',
  '/settings/change-phone-number': '휴대폰 번호 변경',
  '/settings/withdraw-account': '회원 탈퇴',
  '/settings/change-password': '비밀번호 변경',
  '/settings/recruit-agreement': '문자 수신 동의',
};
